import { account } from '../core/account.js';
import { i18n, t } from '../core/i18n.js';
import { escapeHtml } from '../core/utils.js';

/* Informes del panel de administración: documentos Markdown guardados en el servidor (DATA_DIR/docs), ya convertidos a HTML allí
   (server/docs.js). Lista y lectura; solo administradores. */

export function openDocsAdmin() {
    const app = window.app;
    const id = 'docsadm-' + Date.now().toString(36);
    const popup = app.popup.create({
        content: `<div class="popup catpick-popup admin-popup" id="${id}">
            <div class="page">
                <div class="navbar"><div class="navbar-bg"></div><div class="navbar-inner">
                    <div class="title">${t('docs.admin.title')}</div>
                    <div class="right"><a href="#" class="link popup-close btn-icon" aria-label="${t('common.close')}"><span class="mi">close</span></a></div>
                </div></div>
                <div class="page-content"><div class="phone-body" data-adm></div></div>
            </div>
        </div>`,
        on: {
            open(p) {
                const body = (p.el || document.getElementById(id)).querySelector('[data-adm]');
                const call = (path) => account.request('GET', path, {});
                const when = (ms) => new Date(ms).toLocaleDateString(i18n.lang, { dateStyle: 'medium' });
                const fail = () => { body.innerHTML = `<div class="phone-status is-error">${t('common.errorNetwork')}</div>`; };
                const listScreen = async () => {
                    body.innerHTML = '<div class="spinner"></div>';
                    let data;
                    try { data = await call('/api/admin/docs/list'); } catch (e) { return fail(); }
                    body.innerHTML = data.docs.length ? data.docs.map((d) => `<button type="button" class="admin-user" data-doc="${escapeHtml(d.id)}" style="width:100%;text-align:left">
                            <span class="admin-avatar mi">description</span>
                            <div class="admin-user-body"><div class="admin-user-name">${escapeHtml(d.title)}</div><div class="admin-user-sub">${escapeHtml(when(d.updatedAt))} · ${Math.round(d.size / 1024)} KB</div></div>
                        </button>`).join('') : `<p class="pw-note">${t('docs.admin.empty')}</p>`;
                };
                const docScreen = async (docId) => {
                    body.innerHTML = '<div class="spinner"></div>';
                    let d;
                    try { d = (await call('/api/admin/docs/get?id=' + encodeURIComponent(docId))).doc; } catch (e) { return fail(); }
                    // El HTML viene del servidor, que lo genera él mismo a partir del Markdown con todo escapado: no es contenido de terceros.
                    body.innerHTML = `<button type="button" class="btn" data-back><span class="mi">arrow_back</span>${t('common.back')}</button><article class="doc-body" data-tv-scroll>${d.html}</article>`;
                    body.querySelector('.page-content, [data-adm]');
                    (p.el || document.getElementById(id)).querySelector('.page-content').scrollTo({ top: 0 });
                };
                body.onclick = (e) => {
                    if (e.target.closest('[data-back]')) return listScreen();
                    const b = e.target.closest('[data-doc]');
                    if (b) docScreen(b.getAttribute('data-doc'));
                };
                listScreen();
            },
            closed() {
                try { popup.destroy(); } catch (e) { /* ya destruido */ }
                const el = document.getElementById(id);
                if (el && el.parentNode) el.parentNode.removeChild(el);
            }
        }
    });
    popup.open();
    return popup;
}
